var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h3 p-2 bg-gray-50 shadow-md"},[_c('span',{staticClass:"hidden lg:inline mr-2"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),(_vm.name)?_c('span',{staticClass:"italic text-gray-400"},[_vm._v("'"+_vm._s(_vm.name)+"'")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }